import { CustomerAccounts } from '@src/containers/Dealer/CustomerAccounts';
import type { CustomerAccountsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerAccountsPanel({ api, params }: LayoutPanelProps<CustomerAccountsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-accounts-panel"
    >
      <CustomerAccounts />
    </EntityAdminPanelShell>
  );
}
